import { Text } from "@chakra-ui/react";
import { ReactNode } from "react";

const StepDescription = ({ children }: { children: ReactNode }) => {
  return (
    <Text mb="28px" fontSize="16px" maxW="600px">
      {children}
    </Text>
  );
};

export default StepDescription;
